(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    // Fallback token built by concatenation so no Liquid-looking tag appears in
    // this javascript block. formatMoney's regex still matches it at runtime.
    var moneyFormat = drawer.dataset.moneyFormat || ('{' + '{amount}' + '}');

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      var formatted = parts.join(',');
      if (moneyFormat.indexOf('{' + '{amount_no_decimals}' + '}') !== -1) {
        formatted = parts[0];
      }
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, formatted);
    }

    var body = drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var upsell = drawer.querySelector('[data-cart-upsell]');

    // The size to recommend: the single distinct variant title across the cart
    // (this theme's variants are sizes). Returns null when the cart mixes sizes
    // or has none, in which case we ask the shopper instead of guessing.
    function cartTargetSize(cart) {
      var sizes = {};
      cart.items.forEach(function (item) {
        if (item.variant_title) sizes[item.variant_title] = true;
      });
      var keys = Object.keys(sizes);
      return keys.length === 1 ? keys[0] : null;
    }

    // Point a recommendation's add button at the right variant:
    //  - default-variant product: add it directly.
    //  - inferred size available: preselect it, show the size caption, add on click.
    //  - otherwise: reveal the size chooser and disable add until a size is picked.
    function configureItem(item, targetSize) {
      var addBtn = item.querySelector('[data-upsell-add]');
      var sizes = item.querySelector('[data-upsell-sizes]');
      var caption = item.querySelector('[data-upsell-size-caption]');

      if (!sizes) {
        addBtn.dataset.variantId = addBtn.dataset.defaultVariantId || addBtn.dataset.variantId;
        addBtn.disabled = false;
        return;
      }

      var buttons = sizes.querySelectorAll('[data-upsell-size]');
      buttons.forEach(function (button) {
        button.classList.remove('is-selected');
        if (!button.disabled) button.setAttribute('aria-pressed', 'false');
      });

      var match = null;
      if (targetSize) {
        for (var i = 0; i < buttons.length; i++) {
          if (!buttons[i].disabled && buttons[i].dataset.size === targetSize) {
            match = buttons[i];
            break;
          }
        }
      }

      if (match) {
        match.classList.add('is-selected');
        match.setAttribute('aria-pressed', 'true');
        addBtn.dataset.variantId = match.dataset.variantId;
        addBtn.disabled = false;
        sizes.hidden = true;
        if (caption) {
          var label = caption.querySelector('[data-upsell-size-label]');
          if (label) label.textContent = targetSize;
          caption.hidden = false;
        }
      } else {
        sizes.hidden = false;
        addBtn.dataset.variantId = '';
        addBtn.disabled = true;
        if (caption) caption.hidden = true;
      }
    }

    // Reveal up to data-max-items recommendations, skipping any product already
    // in the cart. Hidden entirely when the cart is empty or nothing is left to
    // suggest, so it never shows on an empty cart.
    function updateUpsell(cart) {
      if (!upsell) return;
      var items = upsell.querySelectorAll('[data-upsell-item]');
      if (!items.length || !cart || !cart.items.length) {
        upsell.hidden = true;
        return;
      }

      var inCart = {};
      cart.items.forEach(function (item) {
        inCart[item.product_id] = true;
      });

      var targetSize = cartTargetSize(cart);
      var max = parseInt(upsell.dataset.maxItems, 10) || 3;
      var shown = 0;
      items.forEach(function (el) {
        var productId = parseInt(el.dataset.productId, 10);
        if (shown < max && !inCart[productId]) {
          el.hidden = false;
          configureItem(el, targetSize);
          shown += 1;
        } else {
          el.hidden = true;
        }
      });

      upsell.hidden = shown === 0;
    }

    function renderEmpty() {
      body.innerHTML = '<p class="ga-cart-drawer__empty">' + drawer.dataset.i18nEmpty + '</p>';
      footer.hidden = true;
      updateUpsell(null);
    }

    function renderCart(cart) {
      if (!cart.items.length) {
        renderEmpty();
        return;
      }

      footer.hidden = false;
      subtotalEl.textContent = formatMoney(cart.total_price);

      body.innerHTML = cart.items
        .map(function (item, index) {
          var variantLabel = item.variant_title
            ? '<span class="ga-cart-drawer__item-variant">' + item.variant_title + '</span>'
            : '';
          var image = item.image
            ? '<img class="ga-cart-drawer__item-image" src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" width="80" height="80">'
            : '<div class="ga-cart-drawer__item-image"></div>';

          return (
            '<div class="ga-cart-drawer__item" data-cart-key="' + item.key + '">' +
              image +
              '<div class="ga-cart-drawer__item-info">' +
                '<span class="ga-cart-drawer__item-title">' + item.product_title + '</span>' +
                variantLabel +
                '<span class="ga-cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>' +
                '<div class="ga-cart-drawer__item-stepper">' +
                  '<button type="button" data-cart-decrease aria-label="' + drawer.dataset.i18nDecrease + '">&minus;</button>' +
                  '<span class="ga-cart-drawer__item-qty">' + item.quantity + '</span>' +
                  '<button type="button" data-cart-increase aria-label="' + drawer.dataset.i18nIncrease + '">&plus;</button>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="ga-cart-drawer__item-remove" data-cart-remove>' + drawer.dataset.i18nRemove + '</button>' +
            '</div>'
          );
        })
        .join('');

      updateUpsell(cart);
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (response) {
        return response.json();
      });
    }

    // Target the line by its unique line item `key`, never by line index:
    // Shopify reorders the cart (new items go to the front), so a line's
    // position is not stable. Keying by index would change or remove the wrong
    // variant once the order shifts; the key always hits the intended line.
    function changeLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
    }

    function open(cart) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (cart) {
        renderCart(cart);
      } else {
        fetchCart().then(renderCart);
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    body.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-key]');
      if (!line) return;
      var key = line.dataset.cartKey;
      var qtyEl = line.querySelector('.ga-cart-drawer__item-qty');
      var quantity = parseInt(qtyEl.textContent, 10);

      if (e.target.closest('[data-cart-increase]')) {
        changeLine(key, quantity + 1);
      } else if (e.target.closest('[data-cart-decrease]')) {
        changeLine(key, quantity - 1);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeLine(key, 0);
      }
    });

    // Upsell interactions — one delegated listener for both size selection and
    // adding. "Add" posts the resolved variant via the AJAX Cart API, re-renders
    // the cart in place and leaves the drawer open; the just-added product then
    // drops out of the recommendations (it is now in the cart).
    if (upsell) {
      upsell.addEventListener('click', function (e) {
        // Size chooser: mark the picked size, point the item's add button at it.
        var sizeBtn = e.target.closest('[data-upsell-size]');
        if (sizeBtn) {
          if (sizeBtn.disabled) return;
          var group = sizeBtn.closest('[data-upsell-sizes]');
          group.querySelectorAll('[data-upsell-size]').forEach(function (button) {
            var selected = button === sizeBtn;
            button.classList.toggle('is-selected', selected);
            if (!button.disabled) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          var itemAddBtn = sizeBtn.closest('[data-upsell-item]').querySelector('[data-upsell-add]');
          if (itemAddBtn) {
            itemAddBtn.dataset.variantId = sizeBtn.dataset.variantId;
            itemAddBtn.disabled = false;
          }
          return;
        }

        var button = e.target.closest('[data-upsell-add]');
        if (!button || button.disabled) return;

        var variantId = button.dataset.variantId;
        if (!variantId) return;

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var addUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url
          ? window.Shopify.routes.cart_add_url
          : '/cart/add.js';

        button.disabled = true;
        if (!reduceMotion) button.classList.add('is-added');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function () {
            return fetchCart();
          })
          .then(function (cart) {
            renderCart(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function () {
            // On failure, re-enable so the shopper can retry.
            button.disabled = false;
            button.classList.remove('is-added');
          });
      });
    }

    document.addEventListener('cart:open', function (e) {
      open(e.detail && e.detail.cart);
    });

    document.addEventListener('cart:updated', function (e) {
      if (drawer.classList.contains('is-open') && e.detail && e.detail.cart) {
        renderCart(e.detail.cart);
      }

      var count = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
      if (count !== null) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.hidden = count === 0;
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Scroll-snap carousel: native swipe on touch; arrows/dots drive it via
    // scrollTo. The active index is derived from the track's scroll position.
    function slideWidth(track) {
      var slide = track.querySelector('.ga-card__slide');
      return slide ? slide.getBoundingClientRect().width : track.clientWidth;
    }
    function currentIndex(track) {
      var w = slideWidth(track);
      return w ? Math.round(track.scrollLeft / w) : 0;
    }
    function syncControls(carousel) {
      var track = carousel.querySelector('.ga-card__track');
      if (!track) return;
      var slides = carousel.querySelectorAll('.ga-card__slide');
      var dots = carousel.querySelectorAll('.ga-card__dot');
      var prev = carousel.querySelector('.ga-card__arrow--prev');
      var next = carousel.querySelector('.ga-card__arrow--next');
      var index = currentIndex(track);
      var max = slides.length - 1;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
    }
    function scrollToIndex(carousel, index) {
      var track = carousel.querySelector('.ga-card__track');
      if (!track) return;
      var max = carousel.querySelectorAll('.ga-card__slide').length - 1;
      if (index < 0) index = 0;
      if (index > max) index = max;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: index * slideWidth(track), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    document.querySelectorAll('.ga-card__carousel[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.ga-card__track');
      if (!track) return;
      syncControls(carousel);
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          syncControls(carousel);
        });
      }, { passive: true });
    });

    document.addEventListener('click', function (e) {
      var control = e.target.closest('[data-carousel-prev], [data-carousel-next], [data-carousel-dot]');
      if (!control) return;
      var carousel = control.closest('.ga-card__carousel');
      if (!carousel) return;
      e.preventDefault();

      var track = carousel.querySelector('.ga-card__track');
      var index = currentIndex(track);
      if (control.hasAttribute('data-carousel-prev')) index -= 1;
      else if (control.hasAttribute('data-carousel-next')) index += 1;
      else {
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('.ga-card__dot'));
        index = dots.indexOf(control);
      }
      scrollToIndex(carousel, index);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-size-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    // Enable the cart actions once a size is chosen; toggle the hint message.
    function gate(form) {
      if (!form) return;
      var input = form.querySelector('[data-size-input]');
      var hasValue = !!(input && input.value !== '');
      form.querySelectorAll('[data-add-to-cart], [data-buy-now]').forEach(function (button) {
        button.disabled = !hasValue;
      });
      // Toggle visibility via a class (not the `hidden` attribute) so the hint
      // keeps its space and nothing below it shifts when a size is picked.
      var message = form.querySelector('[data-variant-message]');
      if (message) message.classList.toggle('is-hidden', hasValue);
    }

    document.addEventListener('click', function (e) {
      var option = e.target.closest('[data-size-option]');
      if (!option || option.disabled) return;

      var picker = option.closest('[data-size-picker]');
      if (!picker) return;

      picker.querySelectorAll('[data-size-option]').forEach(function (button) {
        var selected = button === option;
        button.classList.toggle('is-selected', selected);
        if (!button.disabled) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var input = picker.querySelector('[data-size-input]');
      if (input) input.value = option.dataset.variantId;

      gate(option.closest('form'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
